import React from 'react';
import PropTypes from 'prop-types';

export default function PedingIcon({ fill, size }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 14 14">
      <g transform="translate(487 365)">
        <g transform="translate(-487 -365)" fill="none" stroke={fill} strokeWidth="1">
          <circle cx="7" cy="7" r="7" stroke="none" />
          <circle cx="7" cy="7" r="6.5" fill="none" />
        </g>
        <path
          d="M-826.5-357.1v6l2.919,1.968"
          transform="translate(346.5 -5.529)"
          fill="none"
          stroke={fill}
          strokeWidth="1"
        />
      </g>
    </svg>
  );
}

PedingIcon.defaultProps = {
  size: '14',
  fill: '#4b4b4b'
};

PedingIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
